<mat-accordion [multi]="true" class="w-100"
               fxLayout="column"
               fxLayoutGap="8px">
    @for (faq of faqs; track faq.id; let i = $index) {
        <mat-expansion-panel class="w-100 faq-question-panel">
            <mat-expansion-panel-header fxLayout="start space-between">
                <mat-panel-title class="no-wrap t2-semi-bold">
                    {{ i + 1 }}. {{ faq.question }}
                </mat-panel-title>
                <mat-panel-description fxLayoutAlign="end center" fxLayoutGap="8px">
                    <span class="t4 c-primary-gray-600 no-wrap">
                        {{ 'i18n_af_faqUpdated' | translate }}: {{ (faq.updatedDate ?? faq.createdDate) | date:'dd.MM.yy HH:mm:ss' }}
                    </span>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div fxLayout="row" fxLayoutGap="4px">
                <span class="t3 c-primary-green-800">{{ 'i18n_af_faqAnswer' | translate }}:</span>
                <span class="t3 c-primary-gray-900" [innerHtml]="faq.answer | safeHtml"></span>
            </div>
        </mat-expansion-panel>
    }
</mat-accordion>
